import { gam } from '@cbsinteractive/avia-js-gam';
import { AviaPlugin } from 'tag/ts/tag/player/adapters/avia/plugins/AviaPlugin';
export class GamPlugin extends AviaPlugin {
    package = gam;
    namespaceKey = 'plugin_gam';
    constructor(argument) {
        super({
            ...argument,
            name: 'GamPlugin'
        });
    }
    shouldBeUsed() {
        const contentIsNotLinearAdTrackable = !this.tag?.model?.contentUtilities?.isLinearAdTrackable?.();
        return contentIsNotLinearAdTrackable;
    }
    getFactoryParams() {
        return {
            ...super.getFactoryParams(),
            customPromoUi: true
        };
    }
}
